import type { DesignDocument, ProductConfig } from '../domain/types';
import {
  assertProductionReady,
  createValidationReport,
  validateProductionDesign,
} from './production';
import type { ValidationOptions, ValidationReport, ValidationResult } from './production';

/** Stable UI-facing validation entry point. */
export function validateDesign(
  design: DesignDocument,
  product: ProductConfig,
  options?: ValidationOptions,
): ValidationResult[] {
  return validateProductionDesign(design, product, options);
}

export function validateDesignReport(
  design: DesignDocument,
  product: ProductConfig,
  options?: ValidationOptions,
): ValidationReport {
  return createValidationReport(validateDesign(design, product, options));
}

export {
  assertProductionReady,
  createValidationReport,
  ProductionValidationError,
} from './production';
export type {
  ValidationCode,
  ValidationOptions,
  ValidationReport,
  ValidationResult,
  ValidationSeverity,
} from './production';
export {
  boundsForPoints,
  objectBounds,
  objectCorners,
  rectContainsObject,
  rectContainsPoint,
  rotatePoint,
  unionRects,
} from './geometry';
